import React from 'react'
import Navbar from '../../components/Navbar'
import { useTranslation } from 'react-i18next'
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import FAQContent from './FAQContent';
import Footer from '../../components/Footer';

const FAQ = () => {
  const {t} = useTranslation()

  return (
    <div className='faq bg-primary'>
      <Navbar />
      <div className='container-fluid faq-header pb-50'>
        <div className='container'>
          <div className='col-sm-12 pt-150'>
            <div className='font-weight-bold text-center font-64 faq-header-title'>{t('faq.title')}</div>
            <div className='col-sm-12'>
              <div className='underline-orange'></div>
            </div>
            <div className='col-sm-12 pt-20'>
              <p className='text-white text-center'>{t('faq.sub-title')}</p>
            </div>
          </div>
          <div className='col-sm-12 flex justify-center pt-50 px-0'>
            <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.faq')} />
          </div>
        </div>
      </div>
      <div className="faq-content pb-100">
        <FAQContent/>
      </div>
      <Footer />
    </div>
  )
}

export default FAQ